<script setup>
import OperationsAjustementTab from '@/components/fiche-aim/fiche-aim/ajustement/operation/OperationsAjustementTab.vue'
</script>

<template>
  <v-bottom-sheet :value="active" inset origin="left bottom" persistent @close="$emit('closes')">
    <v-card>
      <v-card-title>Edition d'ajustement</v-card-title>
      <v-card-text>
        <v-textarea
          v-model="tempAjustement.explication"
          class="textarea"
          outlined
          color="secondary"
          label="Justification"
          no-resize
          rows="2"
          required
          :rules="[(v) => !!v || 'Vous devez renseigner une justification']"
        />
        <operations-ajustement-tab
          :postes-disponibles="postesDisponibles"
          :operations="tempAjustement.operations"
          @add="ajouterOperation"
          @update="modifierOperationAjustement"
          @delete="supprimerOperation"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('close')">Annuler</v-btn>
        <v-btn @click="$emit('modifier', tempAjustement)" color="info">Modifier</v-btn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  emits: ['modifier', 'close'],
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    ajustement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tempAjustement: JSON.parse(JSON.stringify(this.ajustement)),
    }
  },
  computed: {
    ...mapGetters({
      postesDisponibles: 'posteAIM/getPostes',
    }),
  },
  methods: {
    ajouterOperation(operation) {
      this.tempAjustement.operations.push(operation)
    },
    modifierOperationAjustement(op) {
      this.supprimerOperation(op.posteAIM.posteAIMId)
      this.ajouterOperation(op)
    },
    supprimerOperation(posteAIMId) {
      console.log('supression', posteAIMId)
      this.tempAjustement.operations.splice(
        this.tempAjustement.operations.findIndex((value) => value.posteAIM.posteAIMId === posteAIMId),
        1
      )
    },
  },
}
</script>
